<template>
    <div class="container justify-content-center  align-items-center flex-wrap pt-8">
      <Message severity="warn" :closable="false">Your email address was not found in RaciApp.<br>Levi has been notified and will send you feedback soon.</Message>
    </div>
</template>
